import { render, staticRenderFns } from "./service-agreement.vue?vue&type=template&id=4da53a1c&scoped=true&"
var script = {}
import style0 from "./service-agreement.vue?vue&type=style&index=0&id=4da53a1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da53a1c",
  null
  
)

export default component.exports